import React, { useMemo } from "react";
import { map } from "lodash";
import { cn } from "@/shared/utils/shadcn";
import { IconButton } from "@/shared/ui/IconButton";
import { ToggleableSection } from "@/shared/ui/ToggleableSection";
import { Pill } from "@/shared/ui/Pill";
import { Row } from "@/shared/ui/Blocks";

const ExamplePromptsSelect = React.memo(
  (props: {
    defaultOpen: boolean;
    isHidden: boolean;
    onSelect: (prompt: string) => void;
    prompts: string[];
  }) => {
    const memoizedContent = useMemo(() => {
      if (props.isHidden) return null;

      return (
        <ToggleableSection
          defaultOpen={props.defaultOpen}
          trigger={({ isOpen, onClick }) => (
            <IconButton
              onClick={onClick}
              icon="ChevronDown"
              variant="round"
              color="darkGrey"
              className={cn(
                "border border-grey-300 my-4",
                !isOpen && "rotate-180"
              )}
            />
          )}
        >
          <Row className="w-full gap-4 flex-wrap justify-center pb-8">
            {map(props.prompts, (prompt) => (
              <Pill
                key={prompt}
                color="purple"
                variant="filled"
                label={prompt}
                onClick={() => props.onSelect(prompt)}
                className="cursor-pointer bg-purple-100 text-purple-500 hover:bg-purple-300 text-center"
              />
            ))}
          </Row>
        </ToggleableSection>
      );
    }, [props.isHidden, props.defaultOpen, props.onSelect, props.prompts]);

    return memoizedContent;
  }
);

ExamplePromptsSelect.displayName = "ExamplePromptsSelect";

export { ExamplePromptsSelect };
